import styled from "styled-components"
import { colors } from "../../../lib/colors"

export const TotalBetsContainer = styled.div<{ jackpot: boolean }>`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 100%;
  color: ${colors.liveBetsGreen};
  padding: 6px;
  background-color: ${colors.liveBetsBackground};
  position: absolute;
  left: 18px;
  top: ${({ jackpot }) => (jackpot ? "90px" : "52px")};
  border-radius: 4px;
  border: 1px solid ${colors.liveBetsGreen};
  text-transform: uppercase;
  min-width: 53px;
  text-align: center;
  z-index: 1;
  @media only screen and (min-width: 375px) {
    top: ${({ jackpot }) => (jackpot ? "112px" : "52px")};
  }
  @media only screen and (min-width: 768px) {
    top: 78px;
    font-size: 18px;
  }
  @media only screen and (min-width: 1024px) {
    top: 0;
    font-size: 22px;
  }
`
